import { withFocusRing } from "@components/Accessibility/FocusRing/FocusRing";
import { Icon } from "@components/Icon";
import { Image } from "@components/Image/Image";
import { Video } from "@components/Video/Video";
import React, { lazy, Suspense } from "react";
import SwiperCore, { Thumbs, Zoom } from "swiper";
import { SwiperSlide } from "swiper/react";
import tw, { styled } from "twin.macro";
import { Badge } from "./Images";
import { ImagesOutputProps } from "./withImages";

SwiperCore.use([Thumbs, Zoom]);

const Swiper = lazy(
  () => import(/* webpackChunkName: "swiper" */ "@components/Swiper/Swiper"),
);

const Container = tw.div`
  bg-white bg-opacity-60
`;
const IconWrapper = withFocusRing(tw.button`
  absolute inset-0 w-full h-full flex items-center justify-center
`);
const StyledIcon = styled(Icon)`
  ${tw`z-10`}
`;
const VideoWrapper = tw.div`
  relative w-full h-full
`;
const VideoContainer = tw.div`
  w-full aspect-12-13 relative
`;
const VideoInner = tw.div`
  absolute inset-0 w-full h-full
`;

const SlideZoom = tw.div`
  w-full h-full
`;

export const MobileImages = ({
  badge,
  images,
  video,
  playing,
  onVideoPlay,
  onSlideChange,
  onSwiperInit,
  thumbsSwiper,
}: ImagesOutputProps) => {
  return (
    <Container>
      {badge && (
        <Badge sale={badge?.name?.toLowerCase() === "sale"} {...badge}>
          {badge?.name}
        </Badge>
      )}
      <Suspense fallback={<></>}>
        <Swiper
          observeParents={true}
          observer={true}
          observeSlideChildren={true}
          onSlideChange={onSlideChange}
          onSwiper={onSwiperInit}
          slidesPerView={1}
          spaceBetween={0}
          thumbs={{ swiper: thumbsSwiper }}
          zoom={true}
        >
          {images?.map((image) => {
            if (image?.isCoverImage && !!video?.url) {
              return (
                <SwiperSlide key={image._id}>
                  <VideoWrapper onClick={onVideoPlay}>
                    <IconWrapper>
                      {!playing && <StyledIcon name="play" />}
                    </IconWrapper>
                    {!playing ? (
                      <Image
                        loading="eager"
                        image={image.src}
                        ratio="12/13"
                        maxWidth={768}
                      />
                    ) : (
                      <VideoContainer>
                        <VideoInner data-testid="mobile-images-video-player">
                          <Video video={video} playing={true} />
                        </VideoInner>
                      </VideoContainer>
                    )}
                  </VideoWrapper>
                </SwiperSlide>
              );
            }
            return (
              <SwiperSlide key={image._id} zoom={true}>
                <SlideZoom className="swiper-zoom-target">
                  <Image
                    alt={image.alt}
                    loading={"eager"}
                    image={image.src || image.url}
                    ratio="12/13"
                    maxWidth={1500}
                  />
                </SlideZoom>
              </SwiperSlide>
            );
          })}
        </Swiper>
      </Suspense>
    </Container>
  );
};
